import { useState } from 'react'
import { trpc } from '@/config/trpc'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/shadcn/card'
import { Input } from '@/components/ui/shadcn/input'

// Support lookup for AppSumo licenses — AppSumo requires customers to be
// findable by license_key. Searches key fragments and account emails.
export function AdminAppsumoTab() {
  const [search, setSearch] = useState('')
  const { data: licenses, isLoading } = trpc.appsumo.adminList.useQuery({
    search: search || undefined,
  })

  return (
    <Card>
      <CardHeader className="bg-card border-b px-6 py-4">
        <CardTitle className="flex w-full items-center justify-between">
          AppSumo Licenses
          <span>{licenses?.length ?? 0} shown</span>
        </CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <div className="border-b p-4">
          <Input
            placeholder="Search by license key or email…"
            className="max-w-md"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm">
            <thead className="bg-card text-muted-foreground text-xs uppercase">
              <tr>
                <th scope="col" className="px-6 py-3">
                  License Key
                </th>
                <th scope="col" className="px-6 py-3">
                  Status
                </th>
                <th scope="col" className="px-6 py-3">
                  Tier
                </th>
                <th scope="col" className="px-6 py-3">
                  User
                </th>
                <th scope="col" className="px-6 py-3">
                  Last Event
                </th>
                <th scope="col" className="px-6 py-3">
                  Updated
                </th>
              </tr>
            </thead>
            <tbody>
              {licenses?.map((license) => (
                <tr className="bg-card border-b" key={license.licenseKey}>
                  <td className="px-6 py-4 font-mono text-xs">
                    {license.licenseKey}
                    {license.prevLicenseKey && (
                      <div className="text-muted-foreground mt-1">
                        replaced {license.prevLicenseKey}
                      </div>
                    )}
                  </td>
                  <td className="px-6 py-4">
                    {license.status === 'active' && (
                      <span className="inline-flex items-center rounded-full bg-green-100 px-2.5 py-0.5 text-xs font-medium text-green-800">
                        Active
                      </span>
                    )}
                    {license.status === 'inactive' && (
                      <span className="inline-flex items-center rounded-full bg-yellow-100 px-2.5 py-0.5 text-xs font-medium text-yellow-800">
                        Inactive
                      </span>
                    )}
                    {license.status === 'deactivated' && (
                      <span className="inline-flex items-center rounded-full bg-red-100 px-2.5 py-0.5 text-xs font-medium text-red-800">
                        Deactivated
                      </span>
                    )}
                  </td>
                  <td className="px-6 py-4">Tier {license.tier}</td>
                  <td className="px-6 py-4">
                    {license.userEmail ?? (
                      <span className="text-muted-foreground">not redeemed</span>
                    )}
                  </td>
                  <td className="px-6 py-4">{license.lastEvent}</td>
                  <td className="px-6 py-4">
                    {license.updatedAt ? new Date(license.updatedAt).toLocaleString() : ''}
                  </td>
                </tr>
              ))}
              {!isLoading && licenses?.length === 0 && (
                <tr>
                  <td className="text-muted-foreground px-6 py-8 text-center" colSpan={6}>
                    No licenses found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  )
}
